module.exports = __webpack_public_path__ + "img/edit.33e52065.svg";